import { TextField } from '@components/base/inputs';
import { VStack } from '@components/base/layout';
import { RepeatableTextInput } from './RepeatableTextInput';

interface SendEmailConfigPanelProps {
  readonly getValue: (field: string) => unknown;
  readonly setValue: (field: string, value: unknown) => void;
}

export function SendEmailConfigPanel({
  getValue,
  setValue,
}: Readonly<SendEmailConfigPanelProps>) {
  return (
    <VStack gap={4}>
      <TextField
        label="To"
        required
        placeholder="e.g. {{user_email}}"
        helperText="Recipient email address. Use {{context_key}} for dynamic values."
        value={(getValue('config_to') as string) ?? ''}
        onChange={(e) => setValue('config_to', e.target.value)}
      />

      <TextField
        label="Template"
        required
        placeholder="e.g. emails.claim-confirmation"
        helperText="Laravel view name for the email template."
        value={(getValue('config_template') as string) ?? ''}
        onChange={(e) => setValue('config_template', e.target.value)}
      />

      <TextField
        label="Subject"
        placeholder="e.g. Your claim has been processed"
        helperText="Optional. Email subject line."
        value={(getValue('config_subject') as string) ?? ''}
        onChange={(e) => setValue('config_subject', e.target.value)}
      />

      <RepeatableTextInput
        label="Data Keys"
        placeholder="e.g. claim_number"
        helperText="Context keys to pass as data to the email template."
        value={(getValue('config_data_keys') as string[]) ?? []}
        onChange={(value) => setValue('config_data_keys', value)}
      />
    </VStack>
  );
}
